import { useStore } from "../store";
import { MutationTypes } from '../store/mutations';

const ApiService = {
  async getUserInfo(accessToken: string) {
    const store = useStore();
    if (store.state.storeid != '0') {
      return;
    }

    const response = await fetch(process.env.VUE_APP_AUTH0_USERINFO_URL, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const data = await response.json();
    
    store.commit(MutationTypes.SET_STOREID, data["http://protractor.com/storeid"]);
    store.commit(MutationTypes.SET_ROLE, data["http://protractor.com/role"]);
  },

  async getStoreDetails(accessToken: string, storeid: string) {
    const store = useStore();
    if (store.state.storename != '' && store.state.storestatus != '') {
      return;
    }

    const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "stores/" + storeid, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const data = await response.json();
    
    store.commit(MutationTypes.SET_STORENAME, data.message.storename);
    store.commit(MutationTypes.SET_STORESTATUS, data.message.storestatus);
  },
};

export default ApiService;